import { Grid2 as Grid } from "@mui/material";
import { Stepper } from "./Stepper";

export const Sidebar = () => (
  <Grid
    sx={{
      backgroundColor: "#f2f2f2",
      minHeight: "100vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-start",
      flexDirection: "column",
      paddingTop: 20,
      paddingInline: 4,
    }}
    size={{ xs: 0, sm: 4, lg: 3 }}
  >
    <Stepper />
  </Grid>
);
